export default class Skill {
    constructor(
        public readonly name: string,
        public readonly value: number
    ) {}
}
